import React from 'react';
import _ from 'lodash';
import {fromJS} from 'immutable';
import {Map} from 'immutable';
import shallowCompare from '../../lib/shallowCompare';
import Modal from '../../../client/components/Modal';
import PaymentMethod from '../PaymentMethod';
import {StripePublishableKey} from '../../config/client';
import CustomerActions from '../../actions/CustomerActions';
import Customer from '../../models/Customer';
import Address from '../../models/Address';
import AddressSearch from '../AddressSearch';
import {isMobileOrTablet} from '../../../client/lib/utils';
import styles from './index.sass';
import menuClosePng from '../images/button_menu_close.png';
import menuCloseSvg from '../images/button_menu_close.svg';

export const Modes = {
  Add: 'add',
  Edit: 'edit',
  Select: 'select'
};
const InputStates = {
  Empty: 'empty',
  Invalid: 'invalid',
  Valid: 'valid'
};

class PaymentMethodModal extends React.Component {
  static contextTypes = {
    executeAction: React.PropTypes.func,
    getUserAgent: React.PropTypes.func,
    trackEvent: React.PropTypes.func
  };

  static propTypes = {
    selectedPaymentMethodId   : React.PropTypes.string,
    paymentMethods            : React.PropTypes.object,
    customer                  : React.PropTypes.instanceOf(Customer),
    storeId                   : React.PropTypes.string,
    mode                      : React.PropTypes.string,
    onCancel                  : React.PropTypes.func.isRequired,
    onSave                    : React.PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = this.getStateFromProps(props);
  }

  getStateFromProps(props) {
    let mode = props.mode ? props.mode : props.paymentMethods.size ? Modes.Select : Modes.Add;
    if (this.state && this.state.mode) {
      mode = this.state.mode;
    }
    let address = new Address({name: props.defaultName ? props.defaultName : null});
    let paymentMethod = fromJS({
        number    : {value: '', state: 'empty'},
        exp_month : {value: '', state: 'empty'},
        exp_year  : {value: '', state: 'empty'},
        cvc       : {value: '', state: 'empty'}
      });
    if (this.state && this.state.newPaymentMethod) {
      paymentMethod = this.state.newPaymentMethod;
    }
    return {
      error                   : null,
      loading                 : false,
      mode                    : mode,
      showManualBilling       : props.showManualBilling ? props.showManualBilling : false,
      selectedPaymentMethodId : props.selectedPaymentMethodId,
      addressSearchSuggestsVisible : false,
      address: address,
      addressState: new Map({
        name: InputStates.Empty,
        addr1: InputStates.Empty,
        addr2: InputStates.Empty,
        city: InputStates.Empty,
        state: InputStates.Empty,
        zip_code: InputStates.Empty
      }),
      newPaymentMethod : paymentMethod
    };
  }

  trackViewEvent() {
    let value = this.state.mode === Modes.Select ? 'payment_method_select' : 'payment_method_enter';
    if(this.props.storeId) {
      value = `checkout_${value}`;
    }
    this.context.trackEvent('view', {value});
  }

  componentDidMount() {
    Stripe.setPublishableKey(StripePublishableKey);
    this.trackViewEvent();
  }

  componentWillReceiveProps(nextProps) {
    this.setState(this.getStateFromProps(nextProps));
    // Auto-select most recently added
    // if(nextProps.paymentMethods.size > this.props.paymentMethods.size) {
    //   this.setState({selectedPaymentMethodId: nextProps.paymentMethods.get(0).id});
    // }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevState.mode !== this.state.mode) {
      this.trackViewEvent();
    }
  }

  handleOnChangePaymentMethod(id) {
    if(id === this.state.selectedPaymentMethodId) {return;}
    this.setState({selectedPaymentMethodId: id});
    this.props.onSave({paymentMethodId: id});
  }

  handleOnChangeNewPaymentMethodInput(field, e) {
    let value = e.target.value.replace(/\D/g, '');
    let state;
    let updates = {};
    switch(field) {
      case 'number':
        if(!value.length) {
          state = 'empty';
        } else {
          value = this.isMobile ? value.slice(0, 16) : formatCreditCardNumber(value);
          state = value.length < 14 ? 'valid' : (Stripe.card.validateCardNumber(value) ? 'valid' : 'invalid');
        }
        break;
      case 'exp_month':
        if(!value.length) {
          state = 'empty';
        } else {
          value = value.slice(0, 2);
          state = 'valid';// (value.length === 2) ? 'valid' : 'invalid';
          if(parseInt(value) > 12) {state = 'invalid';}
        }
       break;
      case 'exp_year':
        if(!value.length) {
          state = 'empty';
        } else {
          value = value.slice(0, 2);
          state = (value.length === 2 && parseInt(value) < 16) ? 'invalid' : 'valid';
        }
        break;
      case 'cvc':
        if(!value.length) {
          state = 'empty';
        } else {
          value = value.slice(0, 4);
          state = value.length < 3 ? 'valid' : (Stripe.card.validateCVC(value) ? 'valid' : 'invalid');
        }
        break;
    }
    updates[field] = {value, state};
    this.setState({
      newPaymentMethod: this.state.newPaymentMethod.merge(updates)
    });
  }

  handleOnKeyDownNewPaymentMethodInput(field, e) {
    if(e.which === 13 && this.validateNewPaymentMethod()) {
      this.handleOnClickContinueButton();
    }
  }

  handleOnClickAddNewPaymentMethodButton(e) {
    this.setState({mode : Modes.Add});
  }

  handleOnClickContinueButton(e) {
    if(this.state.mode === Modes.Add) {
      this.setState({loading : true});
      createStripeToken(this.state.newPaymentMethod, (error, updatedPaymentMethod, stripeTokenObject) => {
        if(error) {
          this.setState({
            loading          : false,
            error            : error,
            newPaymentMethod : updatedPaymentMethod
          });
        }
        let firstInvalidField = null;
        // Required fields
        ['name', 'addr1', 'city', 'state', 'zip_code'].forEach((field) => {
          let val = this.state.address.get(field);
          let state = validateField(field, val);
          if(state === InputStates.Invalid && !firstInvalidField) {
            firstInvalidField = field;
          }
        });
        if(firstInvalidField) {
          return this.setState({
            addressState: this.state.addressState.set(firstInvalidField, InputStates.Invalid),
            loading: false
          });
        }
        let address = this.state.address.toJS();
        if(this.props.customer.isSignedIn()) {
          this.context.executeAction(CustomerActions.addPaymentMethod, {
            payment_method: {
              address: address,
              stripe_token_id: stripeTokenObject.id
            },
            store_id: this.props.storeId // Optional for setting on shoppingcart
          });
          this.props.onSave();
        } else {
          let address = this.state.address.toJS();
          this.props.onSave({
            address: address,
            stripeTokenId: stripeTokenObject.id,
            stripeTokenObject: stripeTokenObject
          });
        }
      });
    }
  }

  handleOnClickRemoveButton(id ,e) {
    e.stopPropagation();
    e.preventDefault();

    if(this.props.customer.isSignedIn()) {
      this.context.executeAction(CustomerActions.removePaymentMethod, {
        payment_method_id: id
      });
    }
  }

  handleOnCloseModal() {
    this.props.onCancel();
  }

  validateNewPaymentMethod() {
    let newPaymentMethod = this.state.newPaymentMethod;
    let addressState = this.state.addressState;
    let isValid = !(
      newPaymentMethod.getIn(['number', 'state']) !== 'valid'
      ||
      newPaymentMethod.getIn(['exp_month', 'state']) !== 'valid'
      ||
      newPaymentMethod.getIn(['exp_year', 'state']) !== 'valid'
      ||
      newPaymentMethod.getIn(['cvc', 'state']) !== 'valid'
    ) && addressState.get('name') !== InputStates.Empty;
    return isValid;
  }

  // Address functions
  handleOnChangeShippingAddressInput(field, e) {
    let value = normalizeValue(field, e.target.value);
    let state = validateField(field, value);
    let addressUpdates = {};
    let addressStateUpdates = {};

    addressUpdates[field] = value;
    addressStateUpdates[field] = state;
    this.setState({
      address: this.state.address.merge(addressUpdates),
      addressState: this.state.addressState.merge(addressStateUpdates)
    });
  }

  handleOnChangeSuggestsAddressSearch(suggestsVisible) {
    this.setState({addressSearchSuggestsVisible : !!suggestsVisible});
    this.context.trackEvent('address_search');
  }

  handleOnSelectSearchSuggest(data) {
    let address = {};
    let addressState = {};
    let streetNumber = '';
    let streetName = '';
    data.gmaps.address_components.forEach(component => {
      if(-1 !== component.types.indexOf('street_number')) {
        streetNumber = component.long_name;
      } else if(-1 !== component.types.indexOf('route')) {
        streetName = component.long_name;
      } else if(-1 !== component.types.indexOf('locality') || -1 !== component.types.indexOf('sublocality')) {
        address.city = component.long_name;
        addressState.city = InputStates.Valid;
      } else if(-1 !== component.types.indexOf('administrative_area_level_1')) {
        address.state = component.short_name;
        addressState.state = InputStates.Valid;
      } else if(-1 !== component.types.indexOf('postal_code')) {
        address.zip_code = component.short_name;
        addressState.zip_code = InputStates.Valid;
      }
    });
    address.addr1 = _.trim(`${streetNumber} ${streetName}`);
    addressState.addr1 = InputStates.Valid;

    this.setState({
      address: new Address(address),
      addressState: new Map(addressState),
      mode: Modes.Add,
      showManualBilling: true
    });
    this.context.trackEvent('select_suggested_address');
  }

  handleOnClickNewShippingAddressButton(e) {
    this.setState({mode: Modes.Add});
  }

  handleOnClickEnterManuallyButton(e) {
    this.setState({showManualBilling: true});
  }

  handleOnClickEditButton(id, e) {
    e.stopPropagation();
    e.preventDefault();

    let address = this.props.shippingAddresses.find((sa) => {return sa.id === id;});
    let addressState = {};
    address.forEach((val, field) => {
      addressState[field] = validateField(field, val);
    });
    this.setState({
      address: address,
      addressState: new Map(addressState),
      mode: Modes.Edit
    });
  }

  renderShippingAddressSearch() {
    let addressSearchProps = {
      placeholder      : 'Enter your address, i.e. 100 Main St',
      autoComplete     : 'off',
      count            : 'us',
      onSuggestSelect  : this.handleOnSelectSearchSuggest.bind(this),
      onChangeSuggests : this.handleOnChangeSuggestsAddressSearch.bind(this)
    };
    if (this.state.showManualBilling) {
      return null;
    }
    return <AddressSearch {...addressSearchProps} />;
  }

  renderEnterAddressManuallyButton() {
    if(this.state.addressSearchSuggestsVisible || this.state.showManualBilling) {return null;}
    let manualLinkProps = {
      onClick: this.handleOnClickEnterManuallyButton.bind(this)
    };
    return (
      <div className={styles.enterManuallySection}>
        <p>or</p>
        <button {...manualLinkProps}>Enter billing manually</button>
      </div>
    );
  }

  renderContinueButton() {
    if(this.state.mode !== Modes.Add) {return null;}
    let disabled = !this.validateNewPaymentMethod();
    let continueButtonProps = {
      className : styles.continueButton,
      disabled  : disabled,
      onClick   : this.handleOnClickContinueButton.bind(this)
    };
    let buttonText = this.state.loading ? <span className="loading-spinner--white" /> : 'Submit';
    return <button {...continueButtonProps}>{buttonText}</button>;
  }

  renderError() {
    if(!this.state.error) {return null;}
    return <span className={styles.error}>{this.state.error}</span>;
  }

  renderPaymentMethods(paymentMethods) {
    if(this.state.mode === Modes.Add) {return null;}
    let selectedPaymentMethodId = this.state.selectedPaymentMethodId;
    return paymentMethods.map(paymentMethod => {
      let id = paymentMethod.id;
      let paymentMethodButtonProps = {
        key           : id,
        className     : styles.paymentMethodButton,
        onClick       : this.handleOnChangePaymentMethod.bind(this, id)
      };
      let paymentMethodProps = {
        className     : styles.paymentMethod,
        includeLeadingBullets: true,
        paymentMethod : paymentMethod
      };
      let inputProps = {
        className     : styles.checkbox,
        type          : 'checkbox',
        name          : id,
        id            : id,
        checked       : selectedPaymentMethodId === id,
        onChange      : this.handleOnChangePaymentMethod.bind(this, id)
      };
      let labelProps = {
        className     : styles.checkboxLabel,
        htmlFor       : id
      };
      let removeButtonProps = {
        className: styles.removeButton,
        onClick: this.handleOnClickRemoveButton.bind(this, id)
      };
      return (
        <div {...paymentMethodButtonProps}>
          <input {...inputProps} />
          <label {...labelProps}>
            <PaymentMethod {...paymentMethodProps} />
          </label>
          <button {...removeButtonProps}>Remove</button>
        </div>
      );
    });
  }

  renderAddNewPaymentMethodButton() {
    if(this.state.mode !== Modes.Select) {return null;}
    let paymentMethodButtonProps = {
      className     : styles.newPaymentMethodButton,
      onClick       : this.handleOnClickAddNewPaymentMethodButton.bind(this)
    };
    return (
      <button {...paymentMethodButtonProps}>Add new card</button>
    );
  }

  renderForm() {
    if(this.state.mode !== Modes.Add) {return null;}
    let isMobile = isMobileOrTablet();
    let newPaymentMethod = this.state.newPaymentMethod;
    let ccNumberInputProps = {
      type        : isMobile ? 'tel' : 'text',
      autoFocus   : true,
      autoComplete: 'cc-number',
      className   : styles.ccNumberInput + (newPaymentMethod.get('number').get('state') === 'invalid' ? (' ' + styles.ccInputInvalid) : ''),
      placeholder : 'Card number',
      value       : newPaymentMethod.get('number').get('value'),
      onChange    : this.handleOnChangeNewPaymentMethodInput.bind(this, 'number'),
      onKeyDown   : this.handleOnKeyDownNewPaymentMethodInput.bind(this, 'number')
    };
    let ccExpMonthInputProps = {
      type        : isMobile ? 'tel' : 'text',
      autoComplete: 'cc-exp-month',
      className   : styles.ccExpMonthInput + (newPaymentMethod.get('exp_month').get('state') === 'invalid' ? (' ' + styles.ccInputInvalid) : ''),
      placeholder : 'MM',
      value       : newPaymentMethod.get('exp_month').get('value'),
      onChange    : this.handleOnChangeNewPaymentMethodInput.bind(this, 'exp_month'),
      onKeyDown   : this.handleOnKeyDownNewPaymentMethodInput.bind(this, 'exp_month')
    };
    let ccExpYearInputProps = {
      type        : isMobile ? 'tel' : 'text',
      autoComplete: 'cc-exp-year',
      className   : styles.ccExpYearInput + (newPaymentMethod.get('exp_year').get('state') === 'invalid' ? (' ' + styles.ccInputInvalid) : ''),
      placeholder : 'YY',
      value       : newPaymentMethod.get('exp_year').get('value'),
      onChange    : this.handleOnChangeNewPaymentMethodInput.bind(this, 'exp_year'),
      onKeyDown   : this.handleOnKeyDownNewPaymentMethodInput.bind(this, 'exp_year')
    };
    let ccCvcInputProps = {
      type        : isMobile ? 'tel' : 'text',
      autoComplete: 'cc-csc',
      className   : styles.ccCvcInput + (newPaymentMethod.get('cvc').get('state') === 'invalid' ? (' ' + styles.ccInputInvalid) : ''),
      placeholder : 'CVC',
      value       : newPaymentMethod.get('cvc').get('value'),
      onChange    : this.handleOnChangeNewPaymentMethodInput.bind(this, 'cvc'),
      onKeyDown   : this.handleOnKeyDownNewPaymentMethodInput.bind(this, 'cvc')
    };
    let cardIcon;
    // if(ccNumberInputProps.value.length) {
    //   cardIcon = <span className={cardIconClassFromNumber(ccNumberInputProps.value)} />;
    // }
    return (
      <div className={styles.form}>
        {this.renderError()}
        <div className={styles.inputContainer}>
          {cardIcon}
          <input {...ccNumberInputProps} />
          <input {...ccExpMonthInputProps} />
          <input {...ccExpYearInputProps} />
          <input {...ccCvcInputProps} />
        </div>
        <div className={styles.footer}>
          <span className={styles.securityMessage}>Secure 256-bit encryption</span>
          <span className={styles.ccAmericanExpress} />
          <span className={styles.ccMasterCard} />
          <span className={styles.ccDiscover} />
          <span className={styles.ccVisa} />
        </div>
        <div className={styles.billingContainer}>
          <div className={styles.billingHeader}>
            <span className={styles.securityMessage}>Add Billing Address</span>
            {this.renderShippingAddressSearch()}
            {this.renderEnterAddressManuallyButton()}
            {this.renderBillingForm()}
          </div>
        </div>
      </div>
    );
  }

  renderBillingForm() {
    if(!this.state.showManualBilling) {return null;}
    let isMobile = isMobileOrTablet();
    let { address, addressState } = this.state;

    let nameInputProps = {
      type        : 'text',
      autoComplete: 'name',
      autoFocus   : true,
      className   : styles.input + (addressState.get('name') === InputStates.Invalid ? (' ' + styles.inputInvalid) : ''),
      placeholder : 'Full name',
      value       : address.name,
      onChange    : this.handleOnChangeShippingAddressInput.bind(this, 'name')
    };
    let addr1InputProps = {
      type        : 'text',
      autoComplete: 'address-line1',
      className   : styles.input + (addressState.get('addr1') === InputStates.Invalid ? (' ' + styles.inputInvalid) : ''),
      placeholder : 'Address',
      value       : address.addr1,
      onChange    : this.handleOnChangeShippingAddressInput.bind(this, 'addr1')
    };
    let addr2InputProps = {
      type        : 'text',
      autoComplete: 'address-line2',
      className   : styles.input + (addressState.get('addr2') === InputStates.Invalid ? (' ' + styles.inputInvalid) : ''),
      placeholder : 'Apt/Suite (optional)',
      value       : address.addr2,
      onChange    : this.handleOnChangeShippingAddressInput.bind(this, 'addr2')
    };
    let cityInputProps = {
      type        : 'text',
      autoComplete: 'address-level2',
      className   : styles.input + (addressState.get('city') === InputStates.Invalid ? (' ' + styles.inputInvalid) : ''),
      placeholder : 'City',
      value       : address.city,
      onChange    : this.handleOnChangeShippingAddressInput.bind(this, 'city')
    };
    let stateInputProps = {
      type        : 'text',
      autoComplete: 'address-level1',
      className   : styles.halfInput + (addressState.get('state') === InputStates.Invalid ? (' ' + styles.inputInvalid) : ''),
      placeholder : 'State',
      value       : address.state,
      onChange    : this.handleOnChangeShippingAddressInput.bind(this, 'state')
    };
    let zipCodeInputProps = {
      type        : 'text',
      autoComplete: 'postal-code',
      className   : styles.halfInput + (addressState.get('zip_code') === InputStates.Invalid ? (' ' + styles.inputInvalid) : ''),
      placeholder : 'Zip code',
      value       : address.zip_code,
      onChange    : this.handleOnChangeShippingAddressInput.bind(this, 'zip_code')
    };
    return (
      <div className={styles.addressForm}>
        {this.renderError()}
        <div className={styles.inputContainer}>
          <input {...nameInputProps} />
          <input {...addr1InputProps} />
          <input {...addr2InputProps} />
          <input {...cityInputProps} />
          <input {...stateInputProps} />
          <input {...zipCodeInputProps} />
        </div>
      </div>
    );
  }

  render() {
    this.isMobile = this.isMobile || this.context.getUserAgent().isMobile;
    let modalProps = {
      onClose: this.handleOnCloseModal.bind(this),
      closeOnOutsideClick: true,
      className: styles.paymentMethodModal
    };
    let header = this.state.mode === Modes.Add ? 'Add Card' : 'Payment method';
    return (
      <Modal {...modalProps}>
        <div className={styles.paymentMethodModalContents}>
          <button className={styles.closeButton} onClick={this.handleOnCloseModal.bind(this)}>
            <img src={menuClosePng} srcSet={menuCloseSvg} />
          </button>
          <h2 className={styles.header}>{header}</h2>
          <div>
            <div>
              {this.renderPaymentMethods(this.props.paymentMethods)}
            </div>
            {this.renderAddNewPaymentMethodButton()}
            {this.renderForm()}
          </div>
          {this.renderContinueButton()}
        </div>
      </Modal>
    );
  }
}

export default PaymentMethodModal;

function cardIconClassFromNumber(num) {
  for (var i = 0; i < cards.length; i++) {
    var n = cards[i];
    if (n.pattern.test(num)){
      return n.iconClass;
    }
  }
  return styles.ccDefault;
}

function cardTypeByNumber(num) {
  for (var i = 0; i < cards.length; i++) {
    var n = cards[i];
    if (n.pattern.test(num)){
      return n.type;
    }
  }
  return null;
}

function formatCreditCardNumber(num) {
  let groupPattern = /(\d{1,4})(\d{1,4})?(\d{1,4})?(\d{1,4})?/;
  for(var i = 0; i < cards.length; i++) {
    var n = cards[i];
    if(n.pattern.test(num) && n.groupPattern){
      groupPattern = n.groupPattern;
    }
  }

  return (num.match(groupPattern) || [])
    .slice(1)
    .filter(Boolean)
    .join(' ');
}

const cards = [
  {
    iconClass: styles.ccDefault,
    pattern: /^3(0|[68])/,
    groupPattern: /(\d{1,4})?(\d{1,6})?(\d{1,4})?/,
    length: 14,
    type: 'Diners Club'
  },
  {
    iconClass: styles.ccDefault,
    pattern: /^35/,
    length: 16,
    type: 'JCB'
  },
  {
    iconClass: styles.ccDiscover,
    pattern: /^6(011(0[0-9]|[2-4]|74|7[7-9]|8[6-9]|9[0-9])|4[4-9]|5)/,
    length: 16,
    type: 'Discover'
  },
  {
    iconClass: styles.ccMasterCard,
    pattern: /^5[1-5]/,
    length: 16,
    type: 'MasterCard'
  },
  {
    iconClass: styles.ccAmericanExpress,
    pattern: /^3[47]\d{13}$/,
    groupPattern: /(\d{1,4})(\d{1,6})?(\d{1,5})?/,
    length: 15,
    type: 'American Express'
  },
  {
    iconClass: styles.ccVisa,
    pattern: /^4\d{12}(\d{3}|\d{6})?$/,
    groupPattern: /(\d{1,4})(\d{1,4})?(\d{1,4})?(\d{1,4})?(\d{1,3})?/,
    length: 16,
    type: 'Visa'
  }
];

function createStripeToken(newPaymentMethod, cb) {
  Stripe.card.createToken({
    number    : newPaymentMethod.get('number').get('value'),
    exp_month : newPaymentMethod.get('exp_month').get('value'),
    exp_year  : newPaymentMethod.get('exp_year').get('value'),
    cvc       : newPaymentMethod.get('cvc').get('value')
  }, (status, response) => {
    if(response.error) {
      let param = response.error.param;
      return cb(response.error.message, newPaymentMethod.setIn([param, 'state'], 'invalid'), null);
    }
    return cb(null, newPaymentMethod, response);
  });
}


function normalizeValue(field, value) {
  switch(field) {
    case 'state':
      value = value.replace(/[^A-z]/g, '').slice(0, 2).toUpperCase();
      break;
    case 'zip_code':
      value = value.replace(/\D/g, '');
      break;
    case 'addr1':
    case 'name':
    case 'addr2':
    case 'city':
    default:
      break;
  }
  return value || '';
}

function validateField(field, value) {
  value = value || '';
  let state;
  switch(field) {
    case 'name':
    case 'addr1':
    case 'city':
      state = value.length ? InputStates.Valid : InputStates.Invalid;
      break;
    case 'state':
      state = (value.length === 2 && STATE_ABBREVIATION_MAP[value]) ? InputStates.Valid : InputStates.Invalid;
      break;
    case 'zip_code':
      state = value.length >= 5 ? InputStates.Valid : InputStates.Invalid;
      break;
    default:
      break;
  }
  return state;
}

const STATE_NAME_MAP = {
  'alabama': 'AL',
  'alaska': 'AK',
  'arizona': 'AZ',
  'arkansas': 'AR',
  'california': 'CA',
  'colorado': 'CO',
  'connecticut': 'CT',
  'delaware': 'DE',
  'district of columbia': 'DC',
  'washington d.c.': 'DC',
  'washington dc': 'DC',
  'florida': 'FL',
  'georgia': 'GA',
  'hawaii': 'HI',
  'idaho': 'ID',
  'illinois': 'IL',
  'indiana': 'IN',
  'iowa': 'IA',
  'kansas': 'KS',
  'kentucky': 'KY',
  'louisiana': 'LA',
  'maine': 'ME',
  'maryland': 'MD',
  'massachusetts': 'MA',
  'michigan': 'MI',
  'minnesota': 'MN',
  'mississippi': 'MS',
  'missouri': 'MO',
  'montana': 'MT',
  'nebraska': 'NE',
  'nevada': 'NV',
  'new hampshire': 'NH',
  'new jersey': 'NJ',
  'new mexico': 'NM',
  'new york': 'NY',
  'north carolina': 'NC',
  'north dakota': 'ND',
  'ohio': 'OH',
  'oklahoma': 'OK',
  'oregon': 'OR',
  'pennsylvania': 'PA',
  'rhode island': 'RI',
  'south carolina': 'SC',
  'south dakota': 'SD',
  'tennessee': 'TN',
  'texas': 'TX',
  'utah': 'UT',
  'vermont': 'VT',
  'virginia': 'VA',
  'washington': 'WA',
  'west virginia': 'WV',
  'wisconsin': 'WI',
  'wyoming': 'WY'
};

const STATE_ABBREVIATION_MAP = _.invert(STATE_NAME_MAP);



// WEBPACK FOOTER //
// banquet/components/PaymentMethodModal/index.js